import React, { useEffect, useState } from 'react'
import { formatCalcSum } from '@shared/utils/helpers'
import { inRange } from 'lodash'

import { InputRange } from '../input-range'

import styles from './style.module.scss'

const DEFAULT_VALUE = 1e6
const minLoan = 2e5
const maxLoan = 15e6

const formatLoanLabel = (value: number) => `${formatCalcSum(value)}`

const getBonusValue = (value: number) => {
	if (inRange(value, minLoan, 1000000)) {
		return 2500
	}

	if (inRange(value, 1000000, 2500000)) {
		return 5000
	}

	if (inRange(value, 2500000, 4000000)) {
		return 9000
	}

	if (inRange(value, 4000000, maxLoan + 1)) {
		return 13000
	}

	return null
}

export const View = () => {
	const [value, setValue] = useState<number>(DEFAULT_VALUE)
	const [bonusValue, setBonusValue] = useState<number | null>(() => getBonusValue(value))

	const loanLabels = React.useMemo(() => {
		return {
			[minLoan]: formatLoanLabel(minLoan),
			[maxLoan / 4]: formatLoanLabel(maxLoan / 4),
			[maxLoan / 2]: formatLoanLabel(maxLoan / 2),
			[maxLoan * 0.75]: formatLoanLabel(maxLoan * 0.75),
			[maxLoan]: formatLoanLabel(maxLoan),
		}
	}, [minLoan, maxLoan])

	const loanProps: React.ComponentProps<typeof InputRange> = {
		view: 'new',
		value,
		onChange: (v: number) => setValue(v),
		min: minLoan,
		max: maxLoan,
		labels: loanLabels,
	}

	useEffect(() => {
		setBonusValue(getBonusValue(value))
	}, [value])

	return (
		<div className={styles.wrapper}>
			<div className={styles.rangeInput}>
				<h5 className={styles.rangeLabel}>Сумма</h5>
				<InputRange {...loanProps} />
			</div>
			<div className={styles.bonusResult}>
				<h5 className={styles.rangeLabel}>Ваш бонус</h5>
				<div className={styles.bonusValue}>{`${bonusValue} ₽`}</div>
			</div>
			<div className={styles.verboseConditions}>
				<a
					className='main-link'
					href={
						'https://storage.yandexcloud.net/creditclub-frontend/static/docs/referral_programs/loans.pdf'
					}
					target='_blank'
					rel='noopener noreferrer nofollow'
				>
					Подробные условия
				</a>
			</div>
		</div>
	)
}
